function isGroupColumn(x) {
  return 'columns' in x;
}

export { isGroupColumn };
